export type StatusFilter = 'all' | 'draft' | 'published'
export type CoverageFilter = 'any' | 'needs' | 'full'

export type SupporterOption = {
  id: string
  fullName: string
}

export type RosterFilters = {
  roles: string[]
  people: string[]
  status: StatusFilter
  coverage: CoverageFilter
}

export const EMPTY_FILTERS: RosterFilters = {
  roles: [],
  people: [],
  status: 'all',
  coverage: 'any',
}

export const isFilterActive = (filters: RosterFilters): boolean =>
  filters.roles.length > 0 || filters.people.length > 0 || filters.status !== 'all' || filters.coverage !== 'any'
